<div class="display-table-row-group">
  @if (showDefaultDisplay) {
  <div class="turnover-risk-display">-</div>
  } @if (showProgressBar) {
  <div class="progress-bar-container">
    <div class="progress-bar-background"></div>
    <div [class]="progressBarClass" [ngStyle]="{width: widthPercent}"></div>
  </div>
  }
</div>
